import { Component, ViewChild, TemplateRef } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import {IRequestPortabilidad} from '../portabilidadweb/RequestPortabilidad'
import { PortabilidadService } from '../../services/portabilidad.service';
import { Observable, firstValueFrom } from 'rxjs';
import { LoginService } from '../../services/login.service';
import { tap, map } from 'rxjs/operators';
import { TokenService } from '../../services/token.service';
import { CommonModule } from '@angular/common';
import { ModalService } from '../../core/services/modal.service';

@Component({
  selector: 'app-solicitud-portabilidad',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './solicitud-portabilidad.component.html',
  styleUrl: './solicitud-portabilidad.component.scss'
})
export class SolicitudPortabilidadComponent {

    @ViewChild('modalCustom') modalCustom!: TemplateRef<any>;

      form!: FormGroup;
      mostrarMensaje = false;
  
    constructor(private readonly modalService: ModalService, private readonly tokenService:TokenService, private readonly fb: FormBuilder,private readonly portabilidadService:PortabilidadService, private readonly loginService: LoginService) {
      this.form = this.fb.group({
        nombres: ['', Validators.required],
        apellidos: ['', Validators.required],
        rut: ['', Validators.required],
        telefono: ['', Validators.required],
        correo: ['', Validators.required],
        direccion: ['', Validators.required],
        comuna: ['', Validators.required],
        region: ['', Validators.required],

        proveedor: ['', Validators.required],
        rutproveedor: ['', Validators.required],

        nombreproveedorreceptor: [{ value: 'UNICARD S.A', disabled: true }],
        rutproveedorreceptor: [{ value: '76086272-K', disabled: true }],

        productosVigentes: this.fb.array([]),
        productosContratar: this.fb.array([])
      });
    }

    get productosVigentes(): FormArray {
  return this.form.get('productosVigentes') as FormArray;
}

get productosContratar(): FormArray {
  return this.form.get('productosContratar') as FormArray;
}

agregarProductoVigente() {
  const producto = this.fb.group({
    producto: [''],
    monto: ['']
  });

  this.productosVigentes.push(producto);
}

eliminarProductoVigente(index: number) {
  this.productosVigentes.removeAt(index);
}

agregarProductoContratar() {
  this.productosContratar.push(this.fb.control(''));
}

eliminarProductoContratar(index: number) {
  this.productosContratar.removeAt(index);
}
    
   async getToken(): Promise<any> {
  const data = await firstValueFrom(this.loginService.getSessionToken());

  console.log("TOKEN ", data);

  if (data) {
    this.tokenService.saveToken(data.token!);
    return data.token;
  }
}

  async startPortabilidad(request:IRequestPortabilidad): Promise<void> {
    console.log("token");

    request.nombreProveedorNuevoReceptor='UNICARD S.A';
    request.rutProveedorNuevoReceptor='76086272-K';

     
    const token = await this.getToken()
    if (token)
    {
   await firstValueFrom(this.datosSolicitud(request)); 
    }

    }

   private datosSolicitud(request: any): Observable<void> {
  console.log("Solicitud de Portabilidad Financiera");



  return this.portabilidadService.solicitudCertificadoLiq(request).pipe(
    tap(() => {
      console.log('Solicitud de Portabilidad Financiera ejecutado');

      // abrir modal
      this.modalService.openModal(this.modalCustom);

      // esperar 5 segundos
      setTimeout(() => {
        this.modalService.closeModal();

        // redirigir
        window.location.href = 'https://www.unipay.cl';

      }, 5000);

    }),
    map(() => {})
  );
}


enviar() {
   if (this.form.invalid) {
    this.form.markAllAsTouched(); // <--- Esto "despierta" a los validadores
    this.mostrarMensaje = true;
    console.log("Formulario inválido, campos faltantes:", this.form.errors);
    return;
  }

  this.mostrarMensaje = false;

  const formValue = this.form.value;

  // Creamos el objeto siguiendo tu interfaz
  const request: IRequestPortabilidad = {
    nombres: formValue.nombres,
    apellidos: formValue.apellidos,
    rut: formValue.rut,
    telefono: formValue.telefono,
    correo: formValue.correo,
    direccion: formValue.direccion,
    comuna: formValue.comuna,
    region: formValue.region,
    
    // Mapeo de nombres distintos entre Form y Modelo
    nombreProveedorInicial: formValue.proveedor,
    rutProveedorInicial: formValue.rutproveedor,
    nombreProveedorNuevoReceptor: formValue.nombreproveedorreceptor,
    rutProveedorNuevoReceptor: formValue.rutproveedorreceptor,
    
    // Valores dinámicos
    productosContratar: formValue.productosContratar, // Es string[]
    productosValores: formValue.productosVigentes    // Es IProductoPortabilidad[]
  };

  console.log('Request listo para enviar:', request);

  // Llamamos al proceso de inicio
  this.startPortabilidad(request);
}



}
